// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"FilterControl_labelContainer__VcY6_","expandCta":"FilterControl_expandCta__K6MkK"};